import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../api/apiInterceptor";
import {displayNotification} from "./notification";


export const fetchAllLocations = createAsyncThunk(
    "fetchAllLocations",
    async({installationId})=>{
        const response = await api.get(`/api/installations/${installationId}/locations/all`);
        return response.data;
    }
)
export const fetchLocations = createAsyncThunk(
    "/api/installations/installationId/locations/fetch",
    async ({installationId, page = 0, pageSize = 10}) => {
        const response = await api.get(`/api/installations/${installationId}/locations?page=${page}&size=${pageSize}`);
        return response.data;
    }
)
export const fetchLocationTableData = createAsyncThunk(
    "fetchLocationTableData",
    async ({installationId, locationId}) => {
        const result = await api.get(`/api/installations/${installationId}/tableviews?loc=${locationId}`)
        return result.data;
    }
)
export const createLocation = createAsyncThunk(
    "/api/installations/installationId/locations/create",
    async ({installationId, data}, {dispatch}) => {
        const response = await api.post(`/api/installations/${installationId}/locations`, data);
        dispatch(fetchLocations({installationId}));
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Kreirano",
            title: "Kreiranje lokacije!"
        }))
        return response.data;
    }
);
export const deleteLocation = createAsyncThunk(
    "/api/installations/installationId/locations/delete",
    async ({installationId, locationId}, {dispatch}) => {
        const response = await api.delete(`/api/installations/${installationId}/locations/${locationId}`);
        //  dispatch(fetchLocations({installationId}));
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Obrisano",
            title: "Brisanje loakcije!"
        }));
        return locationId;
    }
)
export const updateLocation = createAsyncThunk(
    "update-location",
    async ({installationId, locationId, data}, {dispatch}) => {
        const response = await api.put(`/api/installations/${installationId}/locations/${locationId}`, data);
        dispatch(fetchLocations({installationId}));
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Ažurirano",
            title: "Ažuriranje lokacije!"
        }));
        dispatch(hideModal());
        return response.data;
    }
)
export const getAlarmHistory = createAsyncThunk(
    "getAlarmHistory",
    async ({installationId, page = 0}) => {
        const response = await api.get(`/api/installations/${installationId}/alarms?active=false&page=${page}`);
        return response.data;
    }
)
export const getAlarmHistoryForLocation = createAsyncThunk(
    "getAlarmHistoryByLocation",
    async ({installationId, locationId, page = 0}) => {
        const response = await api.get(`/api/installations/${installationId}/alarms?active=false&loc=${locationId}&page=${page}`);

        return response.data;
    }
)
export const sendCommand = createAsyncThunk(
    "sendCommand",
    async ({installationId, data}, {dispatch}) => {
        const response = await api.post(`/api/installations/${installationId}/command`, data)
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Komanda uspješno poslata!",
            title: "Slanje komande!"
        }));
        dispatch(hideCommandsModal());
    }
)
export const fetchConfiguredAlarms = createAsyncThunk(
    "getConfiguredAlarms",
    async ({installationId, deviceId, locationId}) => {
        const response = await api.get(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}/alarms`)
        return response.data;
    }
)
export const mapSlice = createSlice({
    name: "map",
    initialState: {
        location: null,
        locationTableData: [],
        locations: [],
        showModal: false,
        editing: false,
        loading: false,
        pagination: {
            currentPage: 0,
            total: 0,
            pageSize: 0,
        },
        alarms: [],
        alarmsHistory: [],
        alarmsPagination: {
            currentPage: 0,
            totalPages: 0,
        },
        alarmsConfig: [],
        alarmsConfigLoading: false,
        alarmsConfigPagination: {
            currentPage: 0,
            total: 0,
            pageSize: 0,
        },
        showAlarmsModal: false,
        alarmsLoading: false,
        showCommandsModal: false,
    },
    reducers: {
        setLocation: (state, action) => {
            state.location = action.payload;
            state.editing = true;
        },
        setLocations:(state,action)=>{
            state.locations = action.payload;
        },
        openModal: (state) => {
            state.showModal = true;
        },
        hideModal: (state) => {
            state.showModal = false;
            state.editing = false;
        },
        setAlarms: (state, action) => {
            state.alarms = action.payload;
            state.alarmsHistory = [];
        },
        setAlarmsLoading: (state, action) => {
            state.alarmsLoading = action.payload;
        },
        openAlarmsModal: (state) => {
            state.showAlarmsModal = true;
        },
        hideAlarmsModal: (state) => {
            state.showAlarmsModal = false;
        },
        openCommandsModal: (state) => {
            state.showCommandsModal = true;
        },
        hideCommandsModal: (state) => {
            state.showCommandsModal = false;
        },
        clearAlarmsHistory:(state)=>{
            state.alarmsHistory = [];
        }
    }
    ,
    extraReducers: builder => {
        builder
            .addCase(fetchAllLocations.fulfilled,(state,action)=>{
                state.locations = action.payload;
            })
            .addCase(fetchAllLocations.rejected,(state,action)=>{
                state.locations = [];
            })
            .addCase(fetchLocations.pending, state => {
                state.loading = true;
            })
            .addCase(fetchLocations.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.locations = content;
                state.loading = false;
                state.pagination.total = totalElements;
                state.pagination.pageSize = size;
                state.pagination.currentPage = number;
            })
            .addCase(createLocation.fulfilled, (state) => {
                state.showModal = false;
            })
            .addCase(updateLocation.pending, (state) => {

            })
            .addCase(updateLocation.fulfilled, (state, action) => {
                state.editing = false;
                state.location = {
                    ...state.location,
                    ...action.payload
                }
            })
            .addCase(deleteLocation.fulfilled, (state, action) => {
                state.locations = state.locations.filter(item => item.id !== action.payload);
            })
            .addCase(fetchLocationTableData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLocationTableData.fulfilled, (state, action) => {
                state.loading = false;
                state.locationTableData = action.payload;
            })
            .addCase(getAlarmHistory.pending, (state) => {
                state.alarmsLoading = true;
            })
            .addCase(getAlarmHistory.fulfilled, (state, action) => {
                const {content, totalPages, number} = action.payload;
                state.alarmsPagination.currentPage = number;
                state.alarmsPagination.totalPages = totalPages;
                state.alarmsHistory = [...state.alarmsHistory, ...content];
                state.alarmsLoading = false;
            })
            .addCase(getAlarmHistoryForLocation.fulfilled, (state, action) => {
                const {content, totalPages, number} = action.payload;
                state.alarmsPagination.currentPage = number;
                state.alarmsPagination.totalPages = totalPages;
                state.alarmsHistory = [...state.alarmsHistory, ...content];
                state.alarmsLoading = false;
            })
            .addCase(fetchConfiguredAlarms.pending, state => {
                state.alarmsConfigLoading = true;
            })
            .addCase(fetchConfiguredAlarms.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.alarmsConfig = content;
                state.alarmsConfigPagination.total = totalElements;
                state.alarmsConfigPagination.currentPage = number;
                state.alarmsConfigPagination.pageSize = size;
                state.alarmsConfigLoading = false;
            })
    }

})
export const {
    setLocation,
    openModal,
    hideModal,
    setAlarms,
    openCommandsModal,
    hideCommandsModal,
    setAlarmsLoading,
    openAlarmsModal,
    hideAlarmsModal,
    clearAlarmsHistory,
    setLocations
} = mapSlice.actions;
export default mapSlice.reducer;